<template>
  <div class="detail-container">
    <div v-if="type == 'facilities'">
      <div class="title-section">
        <div class="title">
          <span>设备简介</span>
        </div>
        <div class="title-line"></div>
        <div class="title-subtitle">Facilities</div>
      </div>
      <div class="content-section">
        <h1 class="content-title">{{ data.name }}</h1>
        <h3 class="content-subtitle" v-if="data.englishName">{{ data.englishName }}</h3>
        <div class="image-container">
          <el-image
            :src="data.image"
            fit="contain"
            class="detail-image"
          />
        </div>
      </div>
    </div>
    <div v-else>
      <div class="title-section">
        <div class="title">
          <span>{{ data.typeName || '详情' }}</span>
        </div>
        <div class="title-line"></div>
        <div class="title-subtitle">Detail</div>
      </div>
      <div class="content-section">
        <h1 class="content-title">{{ data.title }}</h1>
        <div class="content-meta">
          <span class="meta-item">
            <i class="el-icon-clock"></i>
            {{ formatTimeStamp(data.createdTime * 1000) }}
          </span>
        </div>
        <div class="content-body">
          <div class="ql-editor" v-html="vHtml"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getArticleDetail } from '@/api/api'
import '@/dist/quill.core.css'
import '@/dist/quill.snow.css'
import '@/dist/quill.bubble.css'
export default {
  data () {
    return {
      type: '',
      data: {},
      vHtml: ''
    }
  },
  created () {
    const query = this.$route.query
    this.query = query
    if (!query.type) {
      this.data = JSON.parse(sessionStorage.detail)
      this.type = ''
      this.freshImg(this.data.content)
    }
    if (query.type === 'facilities') {
      this.type = 'facilities'
      this.data = JSON.parse(sessionStorage.detail)
    }
    if (query.type === 'query') {
      this.type = 'query'
      getArticleDetail({ id: query.id }).then(res => {
        this.data = res.data
        this.vHtml = this.data.content
        this.freshImg(this.data.content)
      })
    }
  },
  beforeDestroy () {
    this.data = {}
    this.vHtml = ''
    sessionStorage.detail = ''
  },
  methods: {
    freshImg (text) {
      const regex = new RegExp('<img', 'gi')
      this.data.content = text.replace(regex, `<img style="max-width: 100%; height: auto;"`)
      this.vHtml = this.data.content
    },
    formatTimeStamp (timeStamp) {
      let date = new Date(timeStamp)
      let year = date.getFullYear()
      let month = date.getMonth() + 1
      let day = date.getDate()
      let hour = date.getHours()
      let minute = date.getMinutes()
      let second = date.getSeconds()

      month = month < 10 ? '0' + month : month
      day = day < 10 ? '0' + day : day
      hour = hour < 10 ? '0' + hour : hour
      minute = minute < 10 ? '0' + minute : minute
      second = second < 10 ? '0' + second : second

      return `${year}-${month}-${day} ${hour}:${minute}:${second}`
    }
  }
}
</script>

<style scoped>
.detail-container {
  min-height: 600px;
}

.title-section {
  position: relative;
  margin-bottom: 32px;
}

.title {
  font-size: 36px;
  line-height: 1.4;
  color: #2f4f4f;
  font-weight: 700;
  letter-spacing: 3px;
  animation: titleFloatIn 0.8s cubic-bezier(0.22, 1, 0.36, 1) forwards;
}

.title-subtitle {
  position: absolute;
  right: 0;
  top: 10px;
  font-size: 14px;
  color: #888;
  letter-spacing: 8px;
  text-transform: uppercase;
  animation: subtitleFadeIn 0.8s cubic-bezier(0.22, 1, 0.36, 1) 0.5s forwards;
  opacity: 0;
}

.title-line {
  position: absolute;
  bottom: -8px;
  left: 0;
  width: 80px;
  height: 4px;
  background: linear-gradient(90deg, #2f4f4f, #5a8a8a);
  border-radius: 2px;
  animation: lineSlideIn 1s cubic-bezier(0.22, 1, 0.36, 1) 0.3s forwards;
  transform-origin: left;
  transform: scaleX(0);
}

@keyframes titleFloatIn {
  from {
    opacity: 0;
    transform: translateY(-40px);
    letter-spacing: 10px;
  }
  to {
    opacity: 1;
    transform: translateY(0);
    letter-spacing: 3px;
  }
}

@keyframes subtitleFadeIn {
  from {
    opacity: 0;
    transform: translateX(20px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes lineSlideIn {
  from {
    transform: scaleX(0);
  }
  to {
    transform: scaleX(1);
  }
}

.content-section {
  animation: contentFadeIn 0.8s cubic-bezier(0.22, 1, 0.36, 1) 0.3s forwards;
  opacity: 0;
}

@keyframes contentFadeIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.content-title {
  font-size: 28px;
  font-weight: 600;
  color: #2f4f4f;
  text-align: center;
  margin: 0 0 12px;
  line-height: 1.5;
}

.content-subtitle {
  font-size: 16px;
  color: #888;
  text-align: center;
  margin: 0 0 24px;
  font-weight: 400;
}

.content-meta {
  display: flex;
  justify-content: center;
  margin-bottom: 24px;
}

.meta-item {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  color: #888;
}

.meta-item i {
  font-size: 12px;
}

.image-container {
  display: flex;
  justify-content: center;
  padding: 20px;
  background: #fafafa;
  border-radius: 16px;
  margin-bottom: 24px;
}

.detail-image {
  max-width: 100%;
  max-height: 500px;
  border-radius: 8px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
}

.content-body {
  background: #fff;
  padding: 24px;
  border-radius: 16px;
  box-shadow: 0 4px 15px rgba(47, 79, 79, 0.06);
}

.content-body .ql-editor {
  font-size: 16px;
  line-height: 1.8;
  color: #333;
}

.content-body .ql-editor img {
  max-width: 100%;
  height: auto;
  border-radius: 8px;
  margin: 10px 0;
}

.content-body .ql-editor p {
  margin-bottom: 16px;
}

.content-body .ql-editor h1,
.content-body .ql-editor h2,
.content-body .ql-editor h3 {
  color: #2f4f4f;
  margin-top: 24px;
  margin-bottom: 12px;
}
</style>